<template>
  <div class="flex1">
    <div class="row" v-if="islError">
      <div class="col-12">
        <div class="alert alert-danger" id="islError">{{ islError }}</div>
      </div>
    </div>
    <div class="row titles">
      <div class="col-md-1 col-12">
        Select
      </div>
      <div class="col-md-1 col-12">
        Status
      </div>
      <div class="col-md-3 col-12 vertical-center">
        Isl Key
      </div>
      <div class="col-md-4 col-12 vertical-center">
        Description
      </div>
      <div class="col-md-1 col-12 vertical-center">
        Platform
      </div>
      <div class="col-md-3 col-12">
      </div>
    </div>
    <div class="row mt-3 vertical-center">
      <div class="offset-1 col-md-3 col-12">
        <input class="form-control" type="text" v-model="newISLKey.key" placeholder="New ISL Key" />
      </div>
      <div class="col-md-4 col-12">
        <input class="form-control" type="text" v-model="newISLKey.desc" placeholder="New Description" />
      </div>
      <div class="col-md-1 col-12">
        <select v-model="newISLKey.os">
          <option :value="['ios', 'android']">Both Mobile</option>
          <option :value="['ios']">IOS</option>
          <option :value="['android']">Android</option>
          <option :value="['web']">Web</option>
          <option :value="['ios', 'android', 'web']">All</option>
        </select>
      </div>
      <div class="col-md-1 col-12">
        <button class="btn btn-sm btn-info mx-2" @click="addNewISLKey()">
          ADD
        </button>
      </div>
      <div class="col-md-1 col-12 vertical-center">
        <div class="dropdown">
          <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false">
            Actions
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item" @click="selectAll">Select All</a>
            <a class="dropdown-item" @click="unselectAll">Unselect All</a>
            <a class="dropdown-item" @click="deleteSelectedKeys">Delete Selected</a>
            <a class="dropdown-item" @click="activateSelectedKeys">Activate Selected</a>
            <a class="dropdown-item" @click="deactivateSelectedKeys">Deactivate Selected</a>
            <a class="dropdown-item" @click="convertToCSV('selected')">Export Selected as Csv</a>

          </div>
        </div>
      </div>
    </div>
    <hr class="dashed">
    <div class="row line-hover" v-for="islKey in islKeys" :key="`isl-${islKeys.indexOf(islKey)}-${islKey.id}`"
      @click="$router.push({ name: 'ISLKey', params: { id: islKey.id } })">
      <div class="col-md-1 col-12" style="align-items: center; justify-content: center;" v-on:click="stopPropagation">
        <div class="custom-control custom-checkbox">
          <input class="form-check-input big-checkbox" type="checkbox" :id="islKey.id" :value="islKey.id"
            v-model="editList" @click="toggleEditList(islKey.id)">
        </div>
      </div>
      <div class="col-md-1 col-12 center-para" style="align-items: center; justify-content: center;"
        v-on:click="stopPropagation">
        <button class="btn btn-sm btn-success" style="width:100%;" v-if="islKey.is_active"
          @click="keyActivation(islKey.id, 'deactivate')">Active</button>
        <button class="btn btn-sm center-para" style="width:100%;" v-else
          @click="keyActivation(islKey.id, 'activate')">Passive</button>
      </div>
      <div class="col-md-3 col-12 vertical-center">
        {{ islKey.key }}
      </div>
      <div class="col-md-4 col-12 vertical-center">
        <input v-if="isEditing(islKey.id)" :id="`edit-isl-${islKey.id}`" :value="islKey.desc" class="form-control"
          type="text" placeholder="Description" @click="stopPropagation" />
        <span v-else>
          {{ islKey.desc }}
        </span>
      </div>
      <div class="col-md-1 col-12 center-para" style="align-items: center; justify-content: center;"
        v-on:click="stopPropagation">
        <select v-model="islKey.os" @input="e => editIslKey(islKey.id, e.target.value.split(','))">
          <option :value="undefined" disabled>IOS</option>
          <option :value="['ios']">IOS</option>
          <option :value="['android']">Android</option>
          <option :value="['ios', 'android']">Both Mobile</option>
          <option :value="['ios', 'android', 'web']">All</option>
          <option :value="['web']">Web</option>
        </select>
      </div>
      <div class="col-md-2 col-12" v-on:click="stopPropagation">
        <button class="btn btn-sm mx-2" @click="convertToCSV(islKey.id)">
          Export
        </button>
        <button class="btn btn-sm btn-danger mx-2 action-button" @click="deleteISLKey(islKey.id)">
          Del
        </button>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-6">
        <button class="btn mr-3" @click="allKeysActivation('activate')">Activate all keys</button>
        <button class="btn mr-3" @click="allKeysActivation('deactivate')">Deactivate all keys</button>
      </div>
      <div class="col-6 text-right">
        <button class="btn btn mr-3" @click="convertToCSV('all')">Export keys as csv</button>
        <span class="btn btn-primary btn-file">
          Import CSV
          <input type="file" name="..." @change="importCSV">
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Papa from 'papaparse';
import crypto from 'crypto';

export default {
  data() {
    return {
      newISLKey: {
        os: ['ios', 'android']
      },
      editList: [],
      islError: undefined,
    };
  },
  computed: {
    islKeys() {
      return this.$store.getters.islKeys;
    }
  },
  methods: {
    activateSelectedKeys() {
      this.editList.forEach(id => {
        this.keyActivation(id, 'activate')
      })
      this.unselectAll();
    },
    deactivateSelectedKeys() {
      this.editList.forEach(id => {
        this.keyActivation(id, 'deactivate')
      })
      this.unselectAll();
    },
    unselectAll() {
      this.editList = []
    },
    selectAll() {
      this.editList = this.islKeys.map(isl => isl.id);
    },
    deleteSelectedKeys() {
      const deleteItems = this.editList
      this.editList = []
      if (confirm("Selected keys will be deleted, are you sure?")) {
        for (let i = 0; i < deleteItems.length; i++) {
          this.$store.dispatch("configDelete", { type: 'isl', payload: deleteItems[i] });
        }
      }
    },
    toggleEditList(id) {
      const index = this.editList.indexOf(id)
      if (index > -1) {
        this.editList.splice(index, 1)
      }
      else {
        this.editList.push(id)
      }
    },
    stopPropagation(event) {
      event.stopPropagation();
    },
    addNewISLKey() {
      const restrictedKeys = this.islKeys.map(item => item.key)
      if (this.newISLKey.key && restrictedKeys.indexOf(this.newISLKey.key) < 0 && this.newISLKey.desc) {
        this.newISLKey.created_at = new Date() * 1
        this.$store.dispatch("configAdd", { type: 'isl', payload: this.newISLKey });
        this.newISLKey = {};
      } else {
        this.islError = "A field is missing or isl key is not available"
        document.scrollTop()
      }
    },
    deleteISLKey(id) {
      if (confirm(`You are trying to delete "${this.islKeys.find(item => item.id == id).key}" isl key. Are you sure?`)) {
        this.$store.dispatch("configDelete", { type: 'isl', payload: id });
      }
    },
    generateFirestoreId(key) {
      const hash = crypto.createHash('sha256').update(key).digest();
      return hash.slice(0, 10).toString('hex');
    },
    // TODO: if there are any ; within the column, this also count it as column delimiter. fix it later.
    importCSV(event) {
      const reader = new FileReader();
      const vm = this
      reader.onload = function () {
        const jsonData = []
        const contents = reader.result;
        const parseResult = Papa.parse(contents, [, {
          download: true,
          header: true,
          complete: (results) => {
            this.csvData = results.data;
          },
        }]);
        const rows = parseResult.data
        rows.shift()
        rows.forEach(rowArr => {
          const row = rowArr.join(";")
          let [key, audienceName, desc, lang, value, audienceId, id, isActive] = row.split(';')
          key = key.trimEnd()
          audienceId = audienceId.trimEnd()
          const boolIsActive = isActive === "TRUE"
          let islIndex = -1
          if (!id) {
            id = vm.generateFirestoreId(key)
          }
          for (let i = 0; i < jsonData.length; i++) {
            if (jsonData[i].id == id) {
              islIndex = i;
              break;
            }
          }
          if (islIndex < 0) {
            islIndex = jsonData.length
            // os changes according to selected os at the top select platform model
            jsonData.push({ id, key, desc, is_active: boolIsActive, os: vm.newISLKey.os })
          }
          const islKey = jsonData[islIndex]
          if (audienceId == 'default') {
            if (!islKey.default_values) islKey.default_values = {}
            islKey.default_values[lang] = value
          } else {
            if (!islKey.audience_values) islKey.audience_values = {}
            if (!islKey.audience_values[audienceId]) islKey.audience_values[audienceId] = {}
            islKey.audience_values[audienceId][lang] = value
          }
        })
        let payload = []
        jsonData.forEach(key => {
          const id = key.id
          delete key.id
          payload.push({ id: id, data: key })
        })
        vm.$store.dispatch('configEdit', { type: 'isl', payload: { keys: payload } })
      };

      reader.readAsText(event.target.files[0]);
    },
    convertToCSV(id) {
      let jsonData = this.$store.getters.islKeys
      if (id == "selected") {
        jsonData = this.$store.getters.islKeys.filter(item => this.editList.includes(item.id))
      }
      else if (id != 'all') {
        jsonData = this.$store.getters.islKeys.filter(item => item.id == id)
      }
      //console.log(jsonData);
      if (jsonData.length == 0) {
        return "";
      }

      const columnDelimiter = ";";
      const lineDelimiter = "\n";

      const rows = ["key;audienceName;desc;lang;value;audienceId;id;isActive"]
      jsonData.forEach(islKey => {
        console.log(islKey)
        if (islKey.default_values === undefined) {
          islKey['default_values'] = {}
          islKey.default_values["-"] = '-'
        }
        const { default_values, audience_values } = islKey
        if (default_values) {
          Object.keys(default_values).forEach(lang => {
            const row = []
            row.push(islKey.key)
            row.push("default")
            row.push(islKey.desc)
            row.push(lang)
            row.push(default_values[lang])
            row.push("default")
            row.push(islKey.id)
            row.push(islKey.is_active || false)
            rows.push(row.join(columnDelimiter))
          })
        }
        if (audience_values) {
          Object.keys(audience_values).forEach(audience => {
            Object.keys(audience_values[audience]).forEach(lang => {
              const row = []
              row.push(islKey.key)
              row.push(this.getAudienceName(audience))
              row.push(islKey.desc)
              row.push(lang)
              row.push(audience_values[audience][lang])
              row.push(audience)
              row.push(islKey.id)
              row.push(islKey.is_active || false)
              rows.push(row.join(columnDelimiter))
            })
          })
        }


      })
      const dataUri = 'data:text/csv;charset=utf-8,' + encodeURIComponent(rows.join(lineDelimiter));

      const exportFileDefaultName = 'isl.csv';

      const linkElement = document.createElement('a');
      linkElement.setAttribute('href', dataUri);
      linkElement.setAttribute('download', exportFileDefaultName);
      linkElement.click();
    },
    getAudienceName(key) {
      try {
        const audiences = this.$store.getters.audiences;
        const audience = audiences.find((item) => item.id == key);
        return audience.name
      } catch (error) {
        return "Default"
      }
    },
    keyActivation(keyId, operation) {
      this.$store.dispatch('activationOp', { type: 'isl', operation: { [operation]: [keyId] } })
    },
    allKeysActivation(operation) {
      console.log({ [operation]: [...this.islKeys.map(key => key.id)] })
      this.$store.dispatch('activationOp', { type: 'isl', operation: { [operation]: [...this.islKeys.map(key => key.id)] } })
    },
    isEditing(id) {
      return this.editList.indexOf(id) >= 0
    },
    editIslKey(id, os) {
      const islKey = this.islKeys.find(
        (el) => el.id == id
      );
      const data = JSON.parse(JSON.stringify(islKey))
      delete data.id;
      if (os) {
        data.os = os
      }
      this.$store.dispatch("configEdit", { type: 'isl', payload: { id, data } });
      this.editList = this.editList.filter(item => item != id)
    }
  },
};
</script>

<style scoped>
.flex1 {
  color: rgba(255, 255, 255, 0.8);
}

.vertical-center {
  display: flex;
  align-items: center;
}

.action-button {
  padding: 5px 10px;
}

.big-checkbox {
  width: 1.3rem;
  height: 1.3rem;
}
</style>
